module.exports = __webpack_public_path__ + "static/img/012.0f26dd50.png";